import z from 'zod';
import { languageSchema } from '@app/schemas/language';

export const textTranslatableSchema = z.object({
  fallback: languageSchema,
  translations: z.record(
    languageSchema,
    z.string().nonempty({ message: 'Text cannot be empty' }).max(500, { message: 'Text is too long' }),
  ),
});

z.globalRegistry.add(textTranslatableSchema, { id: 'text-translatable' });

export type TextTranslatableSchema = z.infer<typeof textTranslatableSchema>;

export const textActivatableTranslatableSchema = z.object({
  normal: textTranslatableSchema,
  active: textTranslatableSchema.optional(),
});

z.globalRegistry.add(textActivatableTranslatableSchema, { id: 'text-activatable-translatable' });

export type TextActivatableTranslatableSchema = z.infer<typeof textActivatableTranslatableSchema>;
